import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { moduleId: string; children: ReactNode };
type State = { message: string | null };

export default class ModuleBoundary extends Component<Props, State> {
  state: State = { message: null };

  static getDerivedStateFromError(error: unknown): State {
    return { message: error instanceof Error ? error.message : String(error) };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`[module:${this.props.moduleId}] render failed`, error, info.componentStack);
  }

  render() {
    if (this.state.message === null) return this.props.children;
    return (
      <div className="empty" role="alert">
        <b>模块「{this.props.moduleId}」加载失败</b>
        {this.state.message}
        <button
          type="button"
          className="btn btn-ghost btn-sm"
          onClick={() => window.location.reload()}
        >
          重新加载
        </button>
      </div>
    );
  }
}